// Slick Slider
$(document).ready(function(){

  // Image Slider
	$('.image-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 1,
  	});
	});  

  // Header Slider
	$('.header-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: true,
      //speed: 300,
      infinite: false,
      slidesToShow: 1,
      appendDots: slider.parent().find('.header-slider-nav'),
  	});
	});  
  
  // Home Slider
	$('.home-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 800,
      infinite: false,
      fade: true,
      slidesToShow: 1,
      appendDots: slider.parent().find('.home-slider-nav'),
  	});
	});  
  
  // Header Slider Karriere
	$('.header-slider-tile').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: true,
      //speed: 300,
      infinite: false,
      slidesToShow: 1,
      appendDots: slider.parent().find('.header-slider-tile-nav'),
  	});
	});  
  
  // Logo Slider
	$('.logo-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: false,
      slidesToShow: 6,
      swipeToSlide: true,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 5,
            autoplay: true,
            infinite: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 4,
            autoplay: true,
            infinite: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 3,
            autoplay: true,
            infinite: true
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 2,
            autoplay: true,
            infinite: true
          }
        }
      ]
  	});
	});  
  
  // Product Slider
	$('.product-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      appendArrows: slider.parent().find('.product-slider-arrows'),
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 3,
            appendArrows: slider.parent().find('.product-slider-arrows'),
            infinite: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 2,
            appendArrows: slider.parent().find('.product-slider-arrows'),
            infinite: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 2,
            appendArrows: slider.parent().find('.product-slider-arrows'),
            infinite: true
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 1,
            appendArrows: slider.parent().find('.product-slider-arrows'),
            infinite: true
          }
        }
      ]
  	});
	});  
  
  
  // Phase Slider
	$('.phase-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: true,
      dots: false,
      //speed: 300,
      infinite: false,
      slidesToShow: 1,
      adaptiveHeight: true,
      asNavFor: '.phase-slider-nav',
      appendArrows: slider.parent().find('.phase-slider-arrows'),
  	});
	});  
  // Phase Slider Nav
	$('.phase-slider-nav').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 9,
      slidesToScroll: 1,
      adaptiveHeight: false,
      focusOnSelect: true,
      asNavFor: '.phase-slider',
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.phase-slider',
          }
        },
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.phase-slider',
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.phase-slider',
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.phase-slider',
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.phase-slider',
          }
        }
      ]
  	});
    slider.on('setPosition', function(e) {
      //console.log('SetPosition');
      var slidesShown = $(slider).slick('slickGetOption', 'slidesToShow');
      var numberOfSlides = $(slider).find('.slick-slide').length;
      //console.log('slidesShown: '+slidesShown);
      //console.log('numberOfSlides: '+numberOfSlides);
      if (slidesShown === numberOfSlides || slidesShown > numberOfSlides) {
        $(slider).find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
      }
    });
	});  
  
  
  // Milestones Slider
	$('.milestones-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: true,
      dots: false,
      infinite: false,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      asNavFor: '.milestones-slider-nav',
      appendArrows: slider.parent().find('.milestones-slider-arrows')
  	});
	});  
  // Milestones Slider Nav
	$('.milestones-slider-nav').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 8,
      slidesToScroll: 1,
      adaptiveHeight: false,
      focusOnSelect: true,
      asNavFor: '.milestones-slider',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.milestones-slider',
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.milestones-slider',
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.milestones-slider',
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: false,
            focusOnSelect: true,
            asNavFor: '.milestones-slider',
          }
        }
      ]
  	});
	});  

  // Story Slider
	$('.story-slider').each(function () {
  	var slider = $(this);
    var paging = slider.parent().find('.story-slider-paging');
    var progress = slider.parent().find('.story-slider-progress-bar .progress');
    slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      paging.html('<span class="current">'+(i < 10 ? '0'+i : i)+'</span><span class="total">/'+(slick.slideCount < 10 ? '0'+slick.slideCount : slick.slideCount)+'</span>');
      // Progress-Bar
      var oneSlideProgressWidth = 100/slick.slideCount;
      progress.css('width', (i*oneSlideProgressWidth)+'%');
    });
    // Match Height
  	var slideHeight = function (slider) {
      slider.find('.slick-slide .card').height('auto');
      var slickTrackHeight = slider.find('.slick-track').height();
      slider.find('.slick-slide .card').css('height', slickTrackHeight + 'px');
  	};
    slider.on('setPosition', function () {
      slideHeight(slider);
    });
  	slider.slick({
      arrows: true,
      dots: false,
      infinite: true,
      //infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      adaptiveHeight: false,
      appendArrows: slider.parent().find('.story-slider-arrows'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            appendArrows: slider.parent().find('.story-slider-arrows')
          }
        }
      ]
  	});
	});  
  
  
});


// WEBPACK FOOTER //
// ./js/parts/slick.js